<template>
  <div id="">
    <div class="">
      <div class="card-body">
        <div class="row d-flex justify-content-end">
          <!-- <div class="col-sm-6 d-flex justify-content-center justify-content-sm-start align-items-center">
            <div class="divIndicadores">
              <span class="tituloIndicador">OS Proativa</span><br>
              <span class="valorIndicador">9</span>
            </div>
            <div class="divIndicadores">
              <span class="tituloIndicador">OS Corretiva </span><br>
              <span class="valorIndicador">9</span>
            </div>
            <div class="divIndicadores">
              <span class="tituloIndicador">SLA Negativo</span><br>
              <span class="valorIndicador">9</span>
            </div>
          </div> -->
          <div id="divBotoesFiltro" class="col-sm-6  text-sm-right">
            <div v-if="!validaFiltrosAtivos" class="col"></div>
            <div v-if="validaFiltrosAtivos" class="col alert alert-warning text-center" role="alert"
              style="margin-bottom: 0px; margin-right: 3px;">
              Existem filtros salvos e aplicados
            </div>
            <span class="mr-1">Layout: </span>
            <select class="form-control col-12 col-md-3 mr-2" v-model="layoutSelecionado"
              @change="alterarLayout($event)">
              <option value="Cards">Cards</option>
              <option value="Colunas">Colunas</option>
            </select>
            <button style="margin-top: 0px!important" class="btn btn-info btn-sm-block mr-2" id="btnFiltro"
              v-b-toggle.collapse-filtros @click="showFiltros = !showFiltros">
              <i class="fas fa-filter mr-2"></i>
              <span v-if="!showFiltros">
                <!-- Mostrar filtros -->
              </span>
              <span v-if="showFiltros">
                <!-- Esconder filtros -->
              </span>
            </button>
            <button :style="bgColorButtonCriticidade" class="btn btn-info btn-sm-block" @click="refreshPage()"><i
                class="fa fa-undo"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <b-collapse id="collapse-filtros">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              {{ $t('FILTROS') }}
            </div>
            <div class="card-body pt-2 pb-2">

              <indicadores-resumo-armazem></indicadores-resumo-armazem>

              <form action="" class="form">
                <div class="row">
                  <div class="form-group col-md-2">
                    <label>{{ $t('CODIGO OS') }}</label>
                    <input type="number" v-model="internalFilters.codigo" class="form-control" placeholder="99999" />
                  </div>
                  <div class="form-group col-md-2">
                    <label>{{ $t('Placa') }}</label>
                    <v-select :options="veiculos" @input="internalFilters.singlePlaca = $event" placeholder="Placa">
                    </v-select>
                  </div>
                  <div class="form-group col-md-2">
                    <label>{{ $t('Tipo') }}</label>
                    <select v-model="internalFilters.tipo" @change="internalFilters.tipo = $event.target.value"
                      class="form-control">
                      <option value="">{{ $t('TODOS') }}</option>
                      <option v-for="(tipo, index) in osTipos" :value="tipo.nr_sequencial" :key="index">{{ tipo.ds_tipo
                        }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group col-md-2">
                    <label>{{ $t('Ordenar') }}</label>
                    <select class="form-control" v-model="internalFilters.ordenation" placeholder="Ordenar">
                      <option value="ASC">{{ $t('Antigas Primeiro') }}</option>
                      <option value="DESC">{{ $t('Recentes Primeiro') }}</option>
                    </select>
                  </div>
                  <div class="form-group col-md-1">
                    <label>{{ $t('Criticidade') }}</label>
                    <select class="form-control" v-model="internalFilters.criticidade" placeholder="Criticidade">
                      <option value="ASC">{{ $t('Maior') }}</option>
                      <option value="DESC">{{ $t('Menor') }}</option>
                    </select>
                  </div>
                  <div class="form-group col-md-2">
                    <label>{{ $t('Segmentos') }}</label>
                    <v-select :options="grupos" @input="internalFilters.segmento = $event" placeholder="Segmento">
                    </v-select>
                  </div>
                  <div class="form-group col-md-4">
                    <label>{{ $t('Criado por') }}</label>
                    <v-select :options="getAbertoPorArmazem" label="ds_colaborador"
                      :reduce="aberta_por => aberta_por.nr_sequencial" v-model="internalFilters.aberta_por"
                      placeholder="Usuário">
                    </v-select>
                  </div>
                  <div class="form-group col-md-2 align-items-center">
                    <label class="mr-2">{{ $t('Salvar Filtro') }}:</label>
                    <input type="checkbox" @click="setSaveFiltro($event)" v-model="internalFilters.checkSaveFilter">
                  </div>
                  <div class="form-group d-none col-md-4">
                    <label>{{ $t('Período') }}</label>
                    <div class="row">
                      <div class="col-6">
                        <input type="date" class="form-control" v-model="internalFilters.de" />
                      </div>
                      <div class="col-6">
                        <input type="date" class="form-control" v-model="internalFilters.ate" />
                      </div>
                    </div>
                  </div>
                  <div class="form-group d-none col-md-2">
                    <label>{{ $t('Execução') }}</label>
                    <select class="form-control" v-model="internalFilters.executada">
                      <option value="">{{ $t('Todos') }}</option>
                      <option :value="0">{{ $t('Pendentes') }}</option>
                      <option :value="1">{{ $t('Finalizadas') }}</option>
                    </select>
                  </div>
                </div>
              </form>

            </div>
            <div class="card-footer text-right">
              <button class="btn btn-info btn-sm-block float-sm-right" @click="applyFilters">
                <i class="fas fa-filter"></i> {{ $t('Aplicar filtro') }}
              </button>
              <button class="btn btn-outline-dark mr-2 btn-sm-block" @click="resetFilters">
                <i class="fas fa-times"></i> {{ $t('Limpar filtros') }}
              </button>
              <button class="btn btn-outline-dark mr-2 btn-sm-block" v-b-toggle.collapse-filtros
                @click="esconderFiltros()">
                <i class="fas fa-eye-slash"></i> {{ $t('Esconder filtros') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-collapse>
    <div class="col-12 mb-3">
      <!-- <h5 class="col-12 col-sm-3 ">
            Quantidade de OS por nível 
          </h5> -->
      <!-- <button :style="bgColorButtonCriticidade" class="col-12 col-sm-2 btnLimparFiltroVerde" @click="refreshPage()"><i class="fa fa-undo"></i>
        Atualizar</button> -->
    </div>
  </div>
</template>

<script>
import IndicadoresResumoArmazem from '@/components/IndicadoresResumoArmazem'

export default {
  data() {
    return {
      isSidebarOpen: false,
      showFiltros: false,
      checkSaveFilter: false,
      layoutSelecionado: 'Cards'
    }
  },

  components: {
    IndicadoresResumoArmazem

  },
  created(){
    const filtrosAplicados = JSON.parse(localStorage.filtrosArmazem);

    if(filtrosAplicados.checkSaveFilter){
      this.internalFilters = filtrosAplicados
    }

    const layoutStorage = localStorage.getItem('layoutTerminal');
    if (layoutStorage) {
      const tipoLayout = JSON.parse(layoutStorage).tipo_layout;
      this.layoutSelecionado = tipoLayout || 'Cards'; // Define o valor de acordo com o localStorage
    }

    let filters = {
      placa: '',
      tipo: '',
      de: '',
      ate: '',
      codigo: '',
      origem: 'I',
      exibe_terminal: 'S'
    }

    this.$store.commit('os/setFiltersFiltro', { filters: filters })
    this.$store.dispatch('os/getAbertoPor')
  },
  computed: {
    validaFiltrosAtivos() {
      try{
        const filtrosAplicados = JSON.parse(localStorage.filtrosArmazem);

        if(filtrosAplicados.checkSaveFilter){
          return true
        }

        return false
      } catch (e) {
        return false
      }
    },
    osTipos() {
      const items = this.$store.getters['osTipo/items']

      if (!items) {
        this.$store.dispatch('osTipo/fetchFromApi')
      }

      return items
    },

    veiculos() {
      const itemsFiltros = this.$store.getters['veiculo/itemsFiltroArmazem']

      if (!itemsFiltros) {
        this.$store.dispatch('veiculo/fetchFromApiFiltroArmazem')
        return []
      }

      return itemsFiltros.map(item => {
        return item.nr_placa
      })
    },

    bgColorButtonCriticidade() {
      const filter = this.filtros.nr_nivel

      switch(filter) {
        case 0:
          return 'background-image: linear-gradient(45deg, #531218, #dc3646) !important;'
        case 1:
          return 'background-image: linear-gradient(45deg, #763c0a, #fd7f15) !important;'
        case 2:
          return 'background-image: linear-gradient(45deg, rgb(100 78 12), rgb(255 193 8)) !important;'
        case 3:
          return 'background-image: linear-gradient(45deg, #053a72, #007bff) !important;'
        default:
          return 'background: linear-gradient(45deg, #12570d, #1d9c14)!important;'
      }
    },

    filtros() {
      return this.$store.getters['os/filters']
    },

    internalFilters() {
      return { ...this.filtros }
    },

    grupos() {
      const grupos = this.$store.getters['frotaConjunto/grupos']

      if (!grupos) {
        this.$store.dispatch('frotaConjunto/getGrupos', { operacao: 3 })
        return []
      }

      return grupos.map(grupo => {
        return grupo.ds_grupo
      })
    },

    getAbertoPorArmazem() {
      const aberta_por = this.$store.getters['os/aberta_por']

      if (!Array.isArray(aberta_por)) {

        this.$store.dispatch('os/getAbertoPor')
        return []
      }

      return aberta_por.map(item => ({
        ...item,
        label: item.ds_colaborador
      }))
    }
  },
  methods: {
    alterarLayout(event){
      console.log(event)
      const layoutSelecionado = event.target.value

      if(layoutSelecionado == 'Cards'){
        this.$store.commit('os/setPerPage', 12)

        const tipoLayout = {
            tipo_layout: 'Cards'
        }
        localStorage.layoutTerminal = JSON.stringify(tipoLayout);
        
        this.$store.dispatch('os/fetchFromApiFiltroArmazem')
      } else if(layoutSelecionado == 'Colunas'){
        this.$store.commit('os/setPerPage', 500)

        const tipoLayout = {
            tipo_layout: 'Colunas'
        }

        localStorage.layoutTerminal = JSON.stringify(tipoLayout);
        this.$store.dispatch('os/fetchFromApiFiltroArmazem')
      }

      this.$emit('updateLayout')
    },
    setSaveFiltro(check){
      console.log(check.target.checked)

      this.$store.commit('os/setCheckSaveFilter', check.target.checked)
    },
    refreshPage() {
      location.reload()
    },
    
    applyFilters() {
      let filters = { ...this.internalFilters }

      this.$store.commit('os/setFilters', { filters: filters })
      this.$emit('update-filters', { filters: filters })

      this.updateFilters()
      localStorage.setItem('filtrosArmazem', JSON.stringify(filters));
      document.getElementById('btnFiltro').click()
    },

    updateFilters(newFilters) {
      this.$store.dispatch('os/reset')
      this.fetchItemsFromApi()
    },

    fetchItemsFromApi() {
      this.$store.dispatch('os/fetchFromApiArmazem')
    },

    resetFilters() {
      const filters = {
        placa: '',
        tipo: '',
        de: '',
        ate: '',
        codigo: '',
        segmento: ''
      }
      document.getElementById('btnFiltro').click()
      this.$store.commit('os/setFilters', { filters: filters })
      this.$emit('update-filters', { filters: filters })
      localStorage.setItem('filtrosArmazem', JSON.stringify({}));
    },

    esconderFiltros() {
      this.showFiltros = !this.showFiltros
      this.$scrollTo('#osList')
    }
  },

}
</script>
<style src="./NavBar/style.css" scoped />
<style>
  .btnLimparFiltroVerde {
    color: #fff;
    border: none;
    padding: 18px;
    box-shadow: 0px 0px 6px -3px #000;
  }

</style>